
import React from 'react';
import { IconProps } from '../../types/types';

const RightArrow: React.FC<IconProps> = ({ color = '#595959' }) => (
    <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.7346 1.15963L5.45831 4.88735C5.89807 5.32758 5.89769 6.04758 5.45745 6.48735L1.72974 10.2111" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

);

export default RightArrow;